import request from '@/utils/request'

// 查询社区活动COSER申请列表
export function listCommunityGroupActivityCoserApply(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/coser/apply/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询社区活动COSER申请分页
export function pageCommunityGroupActivityCoserApply(query) {
  return request({
    url: '/biz/admin/community/community/group/activity/coser/apply/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询社区活动COSER申请详细
export function getCommunityGroupActivityCoserApply(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/coser/apply/detail',
    method: 'get',
    params: data
  })
}

// 新增社区活动COSER申请
export function addCommunityGroupActivityCoserApply(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/coser/apply/add',
    method: 'post',
    data: data
  })
}

// 修改社区活动COSER申请
export function updateCommunityGroupActivityCoserApply(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/coser/apply/edit',
    method: 'post',
    data: data
  })
}

// 删除社区活动COSER申请

// 审核COSER/摄影师申请
export function auditActivityApply(data) {
  return request({
    url: '/biz/admin/community/activity/apply/audit/audit',
    method: 'post',
    data: data
  })
}
export function delCommunityGroupActivityCoserApply(data) {
  return request({
    url: '/biz/admin/community/community/group/activity/coser/apply/delete',
    method: 'post',
    data: data
  })
}